// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Xdnf","tab":"ProcedureTabs_tab__tiLNK"};